module.exports = __webpack_public_path__ + "img/隐患消缺率@3x.01aa4f38.png";